import { render, staticRenderFns } from "./AddProductMeasureComponent.vue?vue&type=template&id=704ece71&scoped=true"
import script from "./AddProductMeasureComponent.vue?vue&type=script&lang=js"
export * from "./AddProductMeasureComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704ece71",
  null
  
)

export default component.exports